import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setIsSubmit, setErrorPage, setPopUp, reportDWH, reportAnalytics } from '../PremiumPackagesCatalogSlice';
import { premiumPackageActionAsync } from '../premiumPackagesCatalogAsyncThunk';
import PackageHeader from '../Partials/packageHeader/packageHeader';
import PackagePrice from '../Partials/packagePrice/packagePrice';
import Footer from '../Partials/footer/footer';

const PackageBasicPage = (props) => {
    const [isCheckedTerms, setIsCheckedTerms] = useState(false);
    const [termsError, setTermsError] = useState('');

    let isDisplayFooter = true;
    let btnText = 'לרכישה';
    let currentPageFunction = handlePageContinue;
    let formid = 'premiumPackagesCatalogForm';

    let purpleTitle = "";
    let boldTitle1 = "";
    let boldTitle2 = "";
    let extraBoldTitle = props.selectedPackage.cmsData?.selfCare?.title ? props.selectedPackage.cmsData.selfCare.title : props.selectedPackage.localizedName;

    useExtendedEffect((runSideEffects) => {
        props.reportDWH({ actionType: 'Package Page', status: 'Ongoing', messageText: 'Package Page Displayed' });
        if (props.selectedPackage?.cmsData?.selfCare?.isShowWarning) {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_11',
                eventLabel: 'element_13'
            });
            props.setPopUp({ isDisplay: true, type: 'alert', text: props.selectedPackage?.cmsData?.selfCare?.warningText })
        }
        if (runSideEffects()) {
        }
    }, []);

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
            {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
            {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
            {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
        </div>

    );


    let currentPageView = (
        <>
            <PackageHeader selectedPackage={props.selectedPackage} defaultImage={props.defaultImage} />
            <PackagePrice packages={[props.selectedPackage]} lawText={props.selectedPackage?.cmsData?.selfCare?.lawText} isCheckedTerms={isCheckedTerms} termsError={''} onClickTerms={handleOnClickTerms} context={props.context} />
        </>
    );

    return (
        <div>
            {currentPageHeadline}
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
                <Footer isDisplayFooter={isDisplayFooter} errorText={termsError} btnText={btnText} onclick={currentPageFunction} formid={formid} />
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handlePageContinue() {
        if (!isCheckedTerms) {
            setTermsError('כדי להמשיך יש לאשר את תנאי החבילה');
        }
        else {
            if (props.selectedSubscriber.hasDebt) {
                props.setErrorPage({ isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt' });
            }
            else {
                props.premiumPackageActionAsync({ action: "add" });
            }
        }
    }

    function handleOnClickTerms(isChecked) {
        setTermsError('');
        setIsCheckedTerms(isChecked);
    }

};

const mapStateToProps = (state) => {
    return {
        defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
        selectedPackage: state.premiumPackagesCatalog.selectedPackage,
        selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
    };
};

const mapDispatchToProps = {
    goToPage,
    setIsSubmit,
    setErrorPage,
    setPopUp,
    premiumPackageActionAsync,
    reportDWH,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageBasicPage);